<template>
    <AppNavigation>
        <mdb-container fluid>
            <h1 class="h1-responsive">Dispute Orders</h1>
            <hr>
            <mdb-row>
                <mdb-col md="3">
                    <div class="form-group">
                        <mdb-date-picker :autoHide="true" v-model="from" label="Date From" />
                    </div>
                </mdb-col>
                <mdb-col md="3">
                    <div class="form-group">
                        <mdb-date-picker :autoHide="true"  v-model="to" label="Date To" />
                    </div>
                </mdb-col>
                <mdb-col md="6">
                    <mdb-btn @click="getData()" v-if="!loading" outline="primary"><mdb-icon icon="search" /> Search</mdb-btn>
                    <mdb-spinner small v-if="loading" />
                </mdb-col>
            </mdb-row>
            <p class="text-danger" v-if="loading">Please Wait... Fetching Data dont panic don't spam refresh!</p>
            <mdb-tbl responsive striped v-if="!loading">
                <mdb-tbl-head>
                <tr>
                    <th width="3%">#</th>
                    <th width="20%">Order Info</th>
                    <th width="20%">Dispute Info</th>
                    <th width="18%">Customer</th>
                    <th width="18%">Merchant</th>
                    <th width="18%">Rider</th>
                    <th width="6%">Action</th>
                </tr>
                </mdb-tbl-head>
                <mdb-tbl-body>
                    <template v-for="(order, index) in data">
                        <tr :key="order.id">
                            <td>{{index+1}}</td>
                            <td class="text-center">
                                <div v-if="order.service_order.status=='CANCELLED'" class="status-cancelled">{{order.service_order.status}}</div>
                                <div v-if="order.service_order.status=='NEW'" class="status-new">{{order.service_order.status}}</div>
                                <div v-if="order.service_order.status=='COMPLETED'" class="status-completed">{{order.service_order.status}}</div>
                                <div class="font-weight-bold">{{order.order_number}}</div>
                                <div style="text-decoration: line-through;" v-if="order.service_order.service_charge.subtotal != order.service_order.service_charge.grand_total">RM {{order.service_order.service_charge.subtotal}}</div>
                                <div class="d-flex flex-row justify-content-center">
                                    <mdb-tooltip v-if="order.service_order.service_charge.payment_type=='EWALLET_TNG'" trigger="hover" :options="{placement: 'top'}">
                                        <span slot="tip">EGHL TnG</span>
                                        <a slot="reference">
                                        <img :src="require('@/assets/tng.png')" style="height: 20px; width: 20px" />
                                        </a>
                                    </mdb-tooltip>
                                    <mdb-tooltip v-if="order.service_order.service_charge.payment_type=='ONLINE_BANKING'" trigger="hover" :options="{placement: 'top'}">
                                        <span slot="tip">Online Banking</span>
                                        <a slot="reference">
                                        <img :src="require('@/assets/online_banking.png')" style="height: 20px; width: 20px" />
                                        </a>
                                    </mdb-tooltip>
                                    <mdb-tooltip v-if="order.service_order.service_charge.payment_type=='CASH'" trigger="hover" :options="{placement: 'top'}">
                                        <span slot="tip">Cash</span>
                                        <a slot="reference">
                                            <img :src="require('@/assets/cash.png')" style="height: 20px; width: 20px" />
                                        </a>
                                    </mdb-tooltip>
                                    <mdb-tooltip v-if="order.service_order.service_charge.payment_type=='CREDIT_DEBIT_CARD'" trigger="hover" :options="{placement: 'top'}">
                                        <span slot="tip">Card</span>
                                        <a slot="reference">
                                            <img :src="require('@/assets/card.png')" style="height: 20px; width: 20px" />
                                        </a>
                                    </mdb-tooltip>
                                    <mdb-tooltip v-if="order.service_order.service_charge.payment_type=='EWALLET'" trigger="hover" :options="{placement: 'top'}">
                                        <span slot="tip">E-Wallet</span>
                                        <a slot="reference">
                                            <img :src="require('@/assets/e_wallet.png')" style="height: 20px; width: 20px" />
                                        </a>
                                    </mdb-tooltip>
                                    <mdb-tooltip v-if="order.service_order.service_charge.payment_type=='TNG'" trigger="hover" :options="{placement: 'top'}">
                                        <span slot="tip">Touch and Go eWallet</span>
                                        <a slot="reference">
                                            <img :src="require('@/assets/tng.png')" style="height: 20px; width: 20px" />
                                        </a>
                                    </mdb-tooltip>
                                    <div class="ml-2">RM {{order.service_order.service_charge.grand_total}}</div>
                                </div>
                                <div>{{momentFormat16(order.service_order.created_at)}}</div>
                            </td>
                            <td class="text-center">
                                <div>{{order.reference_no}}</div>
                                <div>{{order.reason}}</div>
                                <div>{{order.admin.name}}</div>
                                <div>{{momentFormat16(order.created_at)}}</div>
                                <mdb-input v-if="order.remark" class="white" disabled v-model="order.remark" outline type="textarea" rows="3" />
                                <mdb-row>
                                    <mdb-col md="4" v-for="(image, index) in order.images" v-bind:key="image">
                                        <figure @click="lightboxShow(order.images, index)">
                                            <img :src="getImage(image)" class="img-fluid">
                                        </figure>
                                    </mdb-col>
                                </mdb-row>
                            </td>
                            <td>
                                <div class="order-number-text font-weight-bold" @click="navigateToUser(order.customer.phone_number)">{{order.customer.name}}</div>
                                <div class="mb-1">{{order.customer.phone_number}}</div>
                                <div v-if="order.service_order_refund_id" class="math-add">Refund: RM {{order.compensate_refund_amount}}</div>
                                <div v-if="order.user_join_promo_config_id" class="math-add">Promo Code: RM {{order.compensate_voucher_amount}}</div>
                                <mdb-input v-if="order.customer_remark" class="white" disabled v-model="order.customer_remark" outline type="textarea" rows="3" />
                            </td>
                            <td>
                                <div class="mb-1 order-number-text font-weight-bold" @click="navigateToMerchantList(order.merchant.name)">{{order.merchant.name}}</div>
                                <div v-if="order.merchant_penalty_amount!=0" class="math-minus">Penalty: RM {{order.merchant_penalty_amount}}</div>
                                <div v-if="order.merchant_compensate_amount!=0" class="math-add">Compensate: RM {{order.merchant_compensate_amount}}</div>
                                <mdb-input v-if="order.merchant_remark" class="white" disabled v-model="order.merchant_remark" outline type="textarea" rows="3" />
                            </td>
                            <td>
                                <div v-if="order.partner_user_id" class="mb-1">[ {{order.partner_user.partner_profile.partner_code}} ] - {{order.partner_user.partner_profile.fullname}}</div>
                                <div v-if="order.partner_penalty_amount!=0" class="math-minus">Penalty: RM {{order.partner_penalty_amount}}</div>
                                <div v-if="order.partner_compensate_amount!=0" class="math-add">Compensate: RM {{order.partner_compensate_amount}}</div>
                                <mdb-input v-if="order.partner_remark" class="white" disabled v-model="order.partner_remark" outline type="textarea" rows="3" />
                            </td>
                            <td>
                                <mdb-tooltip trigger="hover" :options="{placement: 'top'}">
                                    <span slot="tip">Show Order Detail</span>
                                    <a slot="reference">
                                        <mdb-btn @click="showOrderDetail(order)" color="primary" size="sm"><mdb-icon far icon="eye" /></mdb-btn>
                                    </a>
                                </mdb-tooltip>
                                <!-- <mdb-tooltip trigger="hover" :options="{placement: 'top'}">
                                    <span slot="tip">Show Dispute Detail</span>
                                    <a slot="reference">
                                        <mdb-btn @click="showDisputeDetail(index)" color="primary" size="sm"><mdb-icon icon="chevron-down" /></mdb-btn>
                                    </a>
                                </mdb-tooltip> -->
                            </td>
                        </tr>
                        <!-- <transition :key="'row2-'+order.id" name="fade">
                        <tr v-show="focus_dispute_index==index+1">
                            <td colspan="7">
                                <mdb-row>
                                    <mdb-col col="6">
                                        <div v-if="order.remark" class="text-muted" style="font-size: 0.8rem">Dispute Remark: <span style="font-size: 1rem; color: #2E2E2E">{{order.remark}}</span></div>
                                        <div v-if="order.customer_remark" class="text-muted">Customer Remark: <span style="font-size: 1rem; color: #2E2E2E">{{order.customer_remark}}</span></div>
                                        <div v-if="order.merchant_remark" class="text-muted">Merchant Remark: <span style="font-size: 1rem; color: #2E2E2E">{{order.merchant_remark}}</span></div>
                                        <div v-if="order.partner_remark" class="text-muted">Rider Remark: <span style="font-size: 1rem; color: #2E2E2E">{{order.partner_remark}}</span></div>
                                    </mdb-col>
                                    <mdb-col col="6">
                                        <mdb-row>
                                            <mdb-col md="4" v-for="(image, index) in order.images" v-bind:key="image">
                                                <figure @click="lightboxShow(order.images, index)">
                                                    <img :src="getImage(image)" class="img-fluid">
                                                </figure>
                                            </mdb-col>
                                        </mdb-row>   
                                    </mdb-col>
                                </mdb-row>
                            </td>
                        </tr>
                        </transition> -->
                    </template>
                </mdb-tbl-body>
            </mdb-tbl>1
        </mdb-container>
        <mdb-lightbox
        :visible="lightbox_modal"
        :imgs="lightbox_imgs"
        :index="lightbox_index"
        @hide="lightbox_modal=false"
        ></mdb-lightbox>
        <OrderDetailComponent :id="focus_order_id" :visible="order_detail_component" :close="closeOrderDetailComponent" :callback="callback" />
    </AppNavigation>
</template>

<script>
// @ is an alias to /src
import {mdbContainer, mdbRow, mdbCol, mdbDatePicker, mdbBtn, mdbSpinner, mdbTbl, mdbTblHead, mdbTblBody, mdbIcon, mdbTooltip, mdbLightbox, mdbInput } from 'mdbvue';
import AppNavigation from '../components/AppNavigation';
import {ajax} from '../js/ajax';
import {momentFormat16, checkPermissionsBinary} from '../js/helper';
import OrderDetailComponent from '../components/OrderDetailComponent';
import { APP_FILE_URL } from '../js/config';

export default {
    name: 'dispute_order',
    components: {
        mdbContainer, mdbRow, mdbCol, mdbDatePicker, mdbBtn, mdbSpinner, mdbTbl, mdbTblHead, mdbTblBody, mdbIcon, mdbTooltip, mdbLightbox,
        AppNavigation, OrderDetailComponent, mdbInput
    },
    data: ()=>({
        loading: false,
        data: [],
        count: 0,
        from: "",
        to: "",
        order_detail_component: false,
        focus_order_id: 0,
        focus_dispute_index: 0,
        lightbox_modal: false,
        lightbox_imgs: [],
        lightbox_index: 0
    }),
    methods: {
            getData(){
                if(!checkPermissionsBinary(60, this.$store.state.permissions)){
                    this.$notify.error({message: "Access Denied.", position: 'top right', timeOut: 5000})
                    return false;
                }
                if(this.loading){
                    return false;
                }
                this.loading=true;
                ajax({
                    url: "admin/get_dispute_orders",
                    data: {
                        from: this.from,
                        to:this.to
                    },
                    complete: ()=>this.loading=false,
                    success: result=>{
                        result.data.disputes.forEach(element => {
                        element.images=JSON.parse(element.images); 
                        });
                        this.data=result.data.disputes;
                        this.count=result.data.count;
                    },
                }, this)
            },
            showOrderDetail(order){
                this.focus_order_id=order.service_order.id;
                this.order_detail_component=true;
            },
            momentFormat16(date){
                return momentFormat16(date);
            },
            closeOrderDetailComponent(){
                this.order_detail_component=false;
            },
            callback(){
                console.log('callback');
            },
            showDisputeDetail(index){
                if(index+1==this.focus_dispute_index){
                    this.focus_dispute_index=0;
                }else{
                    this.focus_dispute_index=index+1;
                }
            },
            getImage(image){
                return APP_FILE_URL+image;
            },
            lightboxShow(images, index){
                var temp_images=[];
                images.forEach(element => {
                    temp_images.push(APP_FILE_URL+element);
                });
                this.lightbox_modal=true,
                this.lightbox_imgs=temp_images,
                this.lightbox_index=index
            },
            navigateToUser(phone){
                if(checkPermissionsBinary(3, this.$store.state.permissions)){
                    this.$router.push({ name: 'users', params: {phone: phone}});
                }
            },
            permissionCheck(permission){
                return checkPermissionsBinary(permission, this.$store.state.permissions);
            },
            navigateToMerchantList(name){
                if(checkPermissionsBinary(20, this.$store.state.permissions)){
                    this.$router.push({ name: 'merchant_list', params: {name: name}});
                }
            },
    },
    mounted: function(){
        if(checkPermissionsBinary(60, this.$store.state.permissions)){
            let date = new Date();
            let month = date.getMonth()+1;
            this.from=date.getFullYear()+'-'+("0" + month).slice(-2)+'-'+("0" + date.getDate()).slice(-2);
            this.to=date.getFullYear()+'-'+("0" + month).slice(-2)+'-'+("0" + date.getDate()).slice(-2);
            this.getData();
        }
    }
}
</script>

<style scoped>
.math-add{
    border: 1.5px solid #00C851;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #00C851;
    margin-bottom: 0.5rem;
    /* font-weight: bold; */
    background-color: #fff;
}

.math-minus{
    border: 1.5px solid #ff4444;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ff4444;
    margin-bottom: 0.5rem;
    /* font-weight: bold; */
    background-color: #fff;
}
.status-cancelled{
    border: 1.5px solid #ff4444;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ff4444;
    background-color: #fff;
}
.status-completed{
    border: 1.5px solid #00C851;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #00C851;
    background-color: #fff;
}
.status-new{
    border: 1.5px solid #4285F4;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #4285F4;
    background-color: #fff;
}
.order-number-text:hover{
    color: #4285F4;
    font-weight: bold;
    cursor: pointer;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>